import React from 'react';
import PropTypes from 'prop-types';
import MREC from '../shared/mrec';

export default function MRECMobile(props) {
  return <MREC ads={props.ads} classNames="mrec-mobile" />;
}

MRECMobile.propTypes = {
  ads: PropTypes.shape({
    path: PropTypes.string.isRequired,
    format: PropTypes.string.isRequired,
    targeting: PropTypes.shape({
      userid: PropTypes.number.isRequired,
      investorType: PropTypes.string,
      investorInterests: PropTypes.arrayOf(PropTypes.string),
      wireid: PropTypes.number,
      contributorid: PropTypes.number,
      category: PropTypes.string,
    }).isRequired,
  }).isRequired,
};
